import { createSlice } from '@reduxjs/toolkit';

import { actions } from './user.actions';
import {
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  LOCAL_STORAGE_USER_ID_KEY,
  LOCAL_STORAGE_REFRESH_TOKEN_KEY,
} from '@shared/lib/contants';

export type IUserInitial = {
  userId: string;
  isAuth: boolean;
  error: string;
  accessToken: string;
  refreshToken: string;
};

const initialState: IUserInitial = {
  userId: localStorage.getItem(LOCAL_STORAGE_USER_ID_KEY) ?? '',
  isAuth: false,
  error: '',
  accessToken: localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY) || '',
  refreshToken: localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY) || '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: actions,
});

export const userReducer = userSlice.reducer;
export const { logout, setCredentials } = userSlice.actions;
